import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { FormGroup, FormControl, ControlLabel, Button } from 'react-bootstrap';
import axios from 'axios';
import { default as config } from '../../../../constants/constants';
import { firebase } from '../../../../firebase';

class CreatePlaylistModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
      validation: null
    };
  }

  playlistNameHandler = (e) => {
    const { value } = e.target;
    this.setState({
      value,
      validation: value.length > 0 ? null : 'error'
    });
  };

  createPlaylist = () => {
    if (firebase.auth.currentUser && this.state.value.trim() !== '') {
      firebase.auth.currentUser.getIdToken().then((token) => {
        const data = {
          name: this.state.value
        };

        const options = {
          method: 'POST',
          headers: { 'X-Firebase-Auth': token },
          url: `${config.serverURL}/playlists/playlist`,
          data
        };
        axios(options)
          .then((res) => {
            // onUpdatePlaylists to renew
            this.props.onCreateNew(token);
            this.onCloseHandler();
          })
          .catch((err) => {
            this.props.onError(err.response.data);
          });
      });
    } else {
      this.setValidationState();
    }
  };

  setValidationState() {
    const length = this.state.value.length;
    this.setState({
      validation: length > 0 ? null : 'error'
    });
  }

  onCloseHandler = () => {
    this.setState({
      value: '',
      validation: null
    });
    this.props.onClose();
  };

  render() {
    const { show, title } = this.props;
    return (
      <Modal
        className="playlist-modal"
        show={show}
        onHide={this.onCloseHandler}
        backdrop={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormGroup
            controlId="formBasicText"
            validationState={this.state.validation}
          >
            <ControlLabel>
              {this.state.validation === 'error'
                ? 'Please provide a name!'
                : ''}
            </ControlLabel>
            <FormControl
              type="text"
              value={this.state.value}
              placeholder="Playlist Name"
              onChange={this.playlistNameHandler}
            />
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <button
                onClick={this.createPlaylist}
                className="save-create-playlist"
              >
                Create Playlist
              </button>
              <Button onClick={this.onCloseHandler}>Cancel</Button>
            </div>
          </FormGroup>
        </Modal.Body>
      </Modal>
    );
  }
}

export default CreatePlaylistModal;
